module.exports = __webpack_public_path__ + "img/DE03592.f79f03aa.png";